module.exports = __webpack_public_path__ + "static/img/sparkelssmall.857b088.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sparkelssmall.gif
// module id = 869
// module chunks = 0